import React from 'react'

import { Flex } from 'components/common/flex/Flex'
import { Typography } from 'components/common/Typography/Typography'

import styles from './HeroBannerContent.module.scss'
import Bubble from '../../common/bubble/Bubble'
import Circle from '../../common/circle/Circle'
import ProjectCounter from '../../common/projectCounter/ProjectCounter'
import Video from '../../common/video/Video'

const title: string = 'Innovation'
const bubbleText: string = 'Step into the time machine'
const text =
  'Calling all future-makers. The Innovation process is designed to put us ahead of the trends and quench consumers’ taste for something new before they’re even thirsty. Be part of making the future at The Coca-Cola company.'
const videoSrc: string = 'https://cokeurl.com/inno-sizzle-v'
const HeroBannerContent = () => {
  const [showCircle, setShowCircle] = React.useState<boolean>(false)
  const [openModal, setOpenModal] = React.useState<boolean>(false)

  return (
    <Flex gap={68} direction="column" className={styles.container}>
      <div className={styles.titleContainer}>
        <h1 className={`text-[80px] leading-[80px] font-bold italic text-white ${styles.title}`}>{title}</h1>
        <Bubble color="#EBFF00" text={bubbleText} className={styles.bubble} />
      </div>
      <Flex gap={61} direction="row" className={styles.contentContainer}>
        <div
          className={styles.videoWrapper}
          onMouseEnter={() => setShowCircle(true)}
          onMouseLeave={() => setShowCircle(false)}
        >
          <Video src={videoSrc} className={styles.videoContainer} openModal={openModal} setOpenModal={setOpenModal} />
          {showCircle && (
            <Circle
              text="Watch it."
              textOnHover="Live it."
              onClick={() => {
                setOpenModal(true)
              }}
            />
          )}
        </div>
        <Flex direction="column" className={styles.textContainer} gap={22}>
          <ProjectCounter text="Projects" />
          <Typography type="l-body" className={styles.text} color="#fff">
            {text}
          </Typography>
        </Flex>
      </Flex>
    </Flex>
  )
}

export default HeroBannerContent
